import {
    CREATERADIOLOGYCATEGORY,
    GETRADIOLOGYCATEGORY,
    UPDATERADIOLOGYCATEGORY,
    DELETERADIOLOGYCATEGORY,
    CREATERADIOLOGYUNIT,
    GETRADIOLOGYUNIT,
    UPDATERADIOLOGYUNIT,
    DELETERADIOLOGYUNIT,
    CREATERADIOLOGYPARAMETER,
    GETRADIOLOGYPARAMETER,
    UPDATERADIOLOGYPARAMETER,
    DELETERADIOLOGYPARAMETER,
    CREATERADIOLOGIST,
    GETRADIOLOGIST,
    UPDATERADIOLOGIST,
    DELETERADIOLOGIST,
    CREATERADIOLOGYCENTER,
    GETRADIOLOGYCENTER,
    UPDATERADIOLOGYCENTER,
    DELETERADIOLOGYCENTER,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATERADIOLOGYCATEGORY:
            return {
                ...state,
                radiologycatrgorySaveStatus: action.payload.success,
            }
        case GETRADIOLOGYCATEGORY:
                return {
                        ...state,
                        radiologycategoryList: action.payload.data,
                        }
        case UPDATERADIOLOGYCATEGORY:
                return {
                        ...state,
                        radiologycategoryUpdateStatus: action.payload.success,
                        }   

        case DELETERADIOLOGYCATEGORY:
                 return {
                     ...state,
                     radiologycategoryDeleteStatus: action.payload.success,
                        } 
        case CREATERADIOLOGYUNIT:
                return {
                        ...state,
                        radiologyunitSaveStatus: action.payload.success,
                        }
        case GETRADIOLOGYUNIT:
                return {
                        ...state,
                        radiologyunitList: action.payload.data,
                       }
        case UPDATERADIOLOGYUNIT:
                return {
                        ...state,
                        radiologyunitUpdateStatus: action.payload.success,
                       }   
                
        case DELETERADIOLOGYUNIT:
                 return {
                        ...state,
                        radiologyunitDeleteStatus: action.payload.success,
                        } 
        case CREATERADIOLOGYPARAMETER:
                return {
                        ...state,
                        radiologyparameterSaveStatus: action.payload.success,
                        }
        case GETRADIOLOGYPARAMETER:
                return {
                        ...state,
                        radiologyparameterList: action.payload.data,
                        }
        case UPDATERADIOLOGYPARAMETER:
                return {
                        ...state,
                        radiologyparameterUpdateStatus: action.payload.success,
                        }   
                            
        case DELETERADIOLOGYPARAMETER:
                return {
                        ...state,
                        radiologyparameterDeleteStatus: action.payload.success,
                        } 
        case CREATERADIOLOGIST:
                return {
                        ...state,
                        radiologistSaveStatus: action.payload.success,
                        }
        case GETRADIOLOGIST:
                return {
                        ...state,
                        radiologistList: action.payload.data,
                       }
        case UPDATERADIOLOGIST:
                return {
                        ...state,
                        radiologistUpdateStatus: action.payload.success,
                       }   
                
        case DELETERADIOLOGIST:
                 return {
                        ...state,
                        radiologistDeleteStatus: action.payload.success,
                        } 
        case CREATERADIOLOGYCENTER:
                return {
                        ...state,
                        radiologycenterSaveStatus: action.payload.success,
                        }
        case GETRADIOLOGYCENTER:
                return {
                        ...state,
                        radiologycenterList: action.payload.data,
                       }
        case UPDATERADIOLOGYCENTER:
                return {
                        ...state,
                        radiologycenterUpdateStatus: action.payload.success,
                       }   
                
        case DELETERADIOLOGYCENTER:
                 return {
                        ...state,
                        radiologycenterDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                                  }
                             }